angular.module('tgaAdmin').service('playerService', [
  '$http',
  'envService',
  'localStorageService',
  'domainService',
  function ($http, envService, localStorageService, domainService) {
    const serverAddress = envService.read('serverAddress');

    function getPlayer(userId, gameId, startDate, endDate) {
      return $http({
        method: 'GET',
        url: `${serverAddress}stats/player/${userId}`,
        params: {
          game_id: gameId,
          start_date: startDate,
          end_date: endDate,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getPlayers(params = {}) {
      return $http({
        method: 'GET',
        url: `${serverAddress}stats/player`,
        params,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getTotalPlayers(game_id, startDate, endDate) {
      return $http({
        method: 'GET',
        url: `${serverAddress}stats/player/total`,
        params: {
          game_id,
          start_date: startDate,
          end_date: endDate,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getNewPlayers(game_id, startDate, endDate) {
      return $http({
        method: 'GET',
        url: `${serverAddress}stats/player/new`,
        params: {
          game_id,
          user_type: 'player',
          start_date: startDate,
          end_date: endDate,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getProgress() {
      return $http({
        method: 'GET',
        url: `${serverAddress}user/player`,
        params: {
          domain: domainService.domain,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function hideSessionEntry(data) {
      return $http({
        method: 'POST',
        url: `${serverAddress}player/session/hide`,
        data: {
          domain: domainService.domain,
          sessions: data.sessions,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getTurnLogs(userId, gameId, startDate, endDate) {
      return $http({
        method: 'GET',
        url: `${serverAddress}player/turnlogs`,
        params: {
          user_id: userId,
          game_id: gameId,
          start_date: startDate,
          end_date: endDate,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    return {
      getPlayer,
      getPlayers,
      getTotalPlayers,
      getNewPlayers,
      getProgress,
      hideSessionEntry,
      getTurnLogs,
    };
  },
]);
